import React, { useState, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { OrderDetailContext } from '../OrderDetailContext';
import { Button, CircularProgress, Grid } from '@material-ui/core';

// SERVICES
import { createCommunicationMessage,  updateInsuredContactInfo, getInsuredContactInfo} from '../../../services';
import SectionHeader from '../../ReactHookForm/SectionHeader';
import CommunicationGrid from '../../CommunicationGrid';
import { AppContext } from '../../../AppContext';
import roles from '../../../helpers/roles';

const styles = theme => ({
  input: {
    background: 'transparent',
    borderWidth: 1,
    border: '1px solid #aaa',
    padding: 5,
    borderRadius: 3,
    // paddingBottom: 5,
    '&:focus': {
      outline: 'none',
    },
  },

  textInput: {
    width: '100%',
    fontSize: 18,
    color: '#777',
    padding: 10,
  },
});

const { ADMIN, QA, UNDERWRITER, UNDERWRITER_READONLY, FIELD_REP } = roles;

export const OrderDetailCommunicationTab = withStyles(styles)(props => {
  const { orderLineId, classes } = props;
  const {
    state: { services },
    dispatch,
  } = useContext(OrderDetailContext);

  const {
    state: { roles: userRoles },
  } = useContext(AppContext);

  const [gridKey, setGridKey] = useState(new Date().getTime()); // used to reinitialize the grid (refetch messages)
  const [newMessage, setNewMessage] = useState('');
  const [contact, setContact] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEmailSubmitting, setIsEmailSubmitting] = useState(false);

  const isFieldRep = userRoles.includes(FIELD_REP);

  const getInsuredContactInfoAsync = async orderLineId => {
    
    const contactInfo = await getInsuredContactInfo(orderLineId);
    setContact(contactInfo)
    
  };


  useEffect(() => {
    (async () => {

      const data = await getInsuredContactInfoAsync(orderLineId);

    })();
    
  },[]);

  const createCommunicationMessageAsync = async evt => {
    evt.preventDefault();

    try {
      setIsSubmitting(true);
      const res = await createCommunicationMessage(orderLineId, newMessage);

      // reset the field
      setNewMessage('');

      // grab messages again to get the new one
      setGridKey(new Date().getTime());
    } catch (error) {
      console.log(error);
    }
    setIsSubmitting(false);
  };

  const updateInsuredContactInfoAsync = async evt => {
    evt.preventDefault();

    try {
      setIsEmailSubmitting(true);
      console.log({contact})
      const res = await updateInsuredContactInfo(orderLineId, contact);

      // reset the field
      setNewMessage('');

      // grab messages again to get the new one
      setGridKey(new Date().getTime());
    } catch (error) {
      console.log(error);
    }
    setIsEmailSubmitting(false);
  };

  return (
    <div
      className={classnames('flex-column')}
      style={{
        height: 'calc(100vh - 215px)', // calculated full height minus header - tabs bar - paddings & margins
      }}
    >
      <div
        style={{
          paddingBottom: 10,
        }}
      >

{!isFieldRep && contact.canEmailInsured && (
<div className={classnames(
            'card',
            'my-10',
            'flex-1',
            'border-left-green',
          )} style={{marginBottom:15}} >
            <SectionHeader title="Insured Contact Info" />
<Grid container >
<Grid item xs={6} style={{marginTop: 15}} >

          <form onSubmit={updateInsuredContactInfoAsync} className={classnames('row-start-center')}>
            <input
              className={classnames(classes.input, classes.textInput, 'flex-1')}
              placeholder="Enter Email Here"
              value={contact.insuredEmail}
              onChange={evt => setContact({...contact, insuredEmail: evt.target.value})}
              disabled={isEmailSubmitting}
              />
            <Button
              style={{
                backgroundColor: '#315382',
                color: '#fff',
                marginLeft: 20,
                width: 200,
              }}
              variant="contained"
              type="submit"
              disabled={isEmailSubmitting}
              >
              {isEmailSubmitting ? <CircularProgress style={{ fill: '#eee', color: '#eee' }} size={20} /> : 'Update Contact'}
            </Button>
          </form>
              </Grid>
                </Grid>

</div>
        )}

        {!isFieldRep && (
          <form onSubmit={createCommunicationMessageAsync} className={classnames('row-start-center')}>
             
            <input
              className={classnames(classes.input, classes.textInput, 'flex-1')}
              placeholder="Enter new message here"
              value={newMessage}
              onChange={evt => setNewMessage(evt.target.value)}
              disabled={isSubmitting}
            />
            <Button
              style={{
                backgroundColor: '#315382',
                color: '#fff',
                marginLeft: 20,
                width: 100,
              }}
              variant="contained"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress style={{ fill: '#eee', color: '#eee' }} size={20} /> : 'Send'}
            </Button>
          </form>
        )}
        
      </div>

      <CommunicationGrid
        key={gridKey}
        gridName="ORDER_DETAIL_COMMUNICATION"
        orderLineId={orderLineId}
        editable={!isFieldRep}
      />
     
    </div>
  );
});

OrderDetailCommunicationTab.propTypes = {};

OrderDetailCommunicationTab.defaultProps = {};
